import React, { useContext } from "react";
import Stepper from "react-stepper-horizontal";
import { LabelContext } from "../../assets/js/labelDataContext";
import OrderDiet from "./OrderDiet";
import OrderDietOption from "./OrderDietOption";
import OrderDate from "./OrderDate";
import OrderAddress from "./OrderAddress";
import OrderConfirm from "./OrderConfirm";
import OrderDay from "./OrderDay";
import OrderSend from "./OrderSend";

const OrderBox = (props) => {
    const value = useContext(LabelContext);
    return (
        
        <section id="order" className="order">
            <div className="container">
                {value.page !== 6 && (
                    <Stepper 
                        steps={value.steps}
                        activeStep={value.page}
                        activeColor="#ffb03b"
                        completeColor="#ffb03b"
                        completeTitleColor="#ffb03b"
                        size={30}
                        titleFontSize={10}
                      />
                )}
                {value.page === 0 && <OrderDiet />}
                {value.page === 1 && <OrderDietOption />}
                {value.page === 2 && <OrderDay />}
                {value.page === 3 && <OrderDate />}
                {value.page === 4 && <OrderAddress />}
                {value.page === 5 && <OrderConfirm />}
                {value.page === 6 && <OrderSend />}
            </div>
        </section>
    )
}

export default OrderBox
